module.exports = __webpack_public_path__ + "media/images/background_home_rotation-6d47c4ea.jpg";